import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import CfopService from 'business/cadastro/fiscal/cfop/cfopService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'

export default function Cfop() {

    const [service] = useState(() => new CfopService())

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_cfop" form={form} service={service} type="number" label="CFOP" minFractionDigits={0} maxFractionDigits={0} />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="descricao_cfop" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cfop_dev_cfop" form={form} service={service} type="number" label="CFOP de devolução" minFractionDigits={0} maxFractionDigits={0} />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cfop_entrada_cfop" form={form} service={service} type="number" label="CFOP de entrada" minFractionDigits={0} maxFractionDigits={0} />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="direito_cred_cfop" form={form} service={service} type="switch" label="Direito a crédito" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="calc_ipi_cfop" form={form} service={service} type="switch" label="calc IPI" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="exige_anp_cfop" form={form} service={service} type="switch" label="Exige ANP" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_trib_cfop" form={form} service={service} type="switch" label="Substituição tributária" />

                    </GridForm>

                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
